export default __webpack_public_path__ + "static/index_illustration-9b25139aa32ed6fb07eaf63482694427.svg";